import React from 'react'

import { Card } from '@/components/cards/Card'

import './LoadingInterstitial.scss'

export const LoadingInterstitialCard = (props) => {
  return (
    <Card data-testid="loading-interstitial-card" compact {...props}>
      <div className="flex-space-between flex-align-center mb">
        <div className="shine is-medium" />
      </div>
      <div className="flex-align-center medium-gap mb">
        <div className="shine is-short is-image" />
        <div className="shine is-long is-image" />
      </div>
      <div className="flex-align-center flex-space-between">
        <div className="shine">&nbsp;</div>
        <div className="shine">&nbsp;</div>
      </div>
    </Card>
  )
}
